import { handleCommonErrors } from 'utils/api'
import {
  InvalidUserUnauthorized,
  InvalidUserWrongAccountUsed,
} from '../useAPIKinerja'

import type { ResetSKPPhase } from 'types/kinerja-penilik-pegawai'

export const basePath = '/guru/pps/v1/penilik' // TODO: confirm to BE
export const queryKeyBaseName = 'penilik-pegawai'

export const apiPaths = {
  basePath,
  profile: `${basePath}/profile`,
  summary: (periodeId: string) => `${basePath}/${periodeId}/summary`,
  status: (periodeId: string) => `${basePath}/${periodeId}/status`,

  // Perencanaan
  perencanaan: `${basePath}/perencanaan`,
  perencanaanByPeriod: (periodeId: string) =>
    `${apiPaths.perencanaan}/${periodeId}`,
  pengembanganKompetensi: `${basePath}/perencanaan/pengembangan-kompetensi`,
  summaryPerencanaan: (periodeId: string) =>
    `${apiPaths.perencanaanByPeriod(periodeId)}/summary`,
  ajukanPerencanaan: (periodeId: string) =>
    `${apiPaths.perencanaan}/${periodeId}/ajukan`,
  mulaiPelaksanaan: `${basePath}/perencanaan/mulai-pelaksanaan`,
  resetSkp: (periodeId: string, phase: ResetSKPPhase) =>
    `${basePath}/${periodeId}/skp/reset/${phase}`,
  syncToEkin: `${basePath}/perencanaan/sync-to-ekin`,

  // Perencanaan Praktik Kinerja
  praktikKinerja: `${basePath}/perencanaan/praktik-kinerja`,
} as const

export const queryKeys = {
  API_GET_PROFILE: `${queryKeyBaseName}-profile`,
  API_GET_SUMMARY: `${queryKeyBaseName}-summary`,
  API_GET_STATUS: `${queryKeyBaseName}-status`,

  // Perencanaan
  API_GET_PERENCANAAN: `${queryKeyBaseName}-perencanaan`,
  API_GET_PERENCANAAN_SUMMARY: `${queryKeyBaseName}-perencanaan-summary`,
  API_GET_PRAKTIK_KINERJA_OPTIONS: `${queryKeyBaseName}-perencanaan-praktik-kinerja`,
  API_GET_SATUAN_PENDIDIKAN_OPTIONS: `${queryKeyBaseName}-perencanaan-satuan-pendidikan`,
  API_GET_PENGEMBANGAN_KOMPETENSI_INDIKATOR: `${queryKeyBaseName}-perencanaan-indikator`,
  API_GET_PENGEMBANGAN_KOMPETENSI_KATEGORI: `${queryKeyBaseName}-perencanaan-kategori`,
  API_GET_PENGEMBANGAN_KOMPETENSI_KEGIATAN: `${queryKeyBaseName}-perencanaan-kegiatan`,
}

export function handleError(status, path, error) {
  if (status === 401) {
    throw new InvalidUserUnauthorized(path, error)
  } else if (status === 403) {
    throw new InvalidUserWrongAccountUsed(path, error)
  } else {
    handleCommonErrors(status, path, error)
  }
}

export function validateStatus(status: number) {
  return status < 400
}
